import {RobotConfig} from "@/components/AiComponent/RobotConfig";


export const getAiConfig = (aiType: any, robot: any) => {
  console.log(aiType,'aiType')
  if (aiType === 'Robot') {
    console.log(robot,'robot');
    return RobotConfig(robot||{});
  }
  return {};
}
